import React, { memo } from "react";
import AppTableCellHeader from "./AppTableCellHeader";
import { TableCellProps } from "@mui/material";

const AppIndexHeader = ({ ...props }: TableCellProps) => {
  return (
    <AppTableCellHeader
      style={{ minWidth: 60, width: 60, maxWidth: 60 }}
      align="center"
      {...props}
    >
      STT
    </AppTableCellHeader>
  );
};

export default memo(AppIndexHeader);
